const DOCUMENT = 'ADMIN_WORKER_FEEDBACK_OPTIONS';

const actions = {
  LOAD: DOCUMENT + 'LOAD',
  LOAD_SUCCESS: DOCUMENT + 'LOAD_SUCCESS',
  CLEAR_STORE: DOCUMENT + 'CLEAR_STORE',
  DELETE: DOCUMENT + 'DELETE',
  ADD: DOCUMENT + 'ADD',
  SHOW_EDIT_MODAL: DOCUMENT + 'SHOW_EDIT_MODAL',
  CLOSE_MODAL: DOCUMENT + 'CLOSE_EDIT_MODAL',
  SHOW_ADD_MODAL: DOCUMENT + 'SHOW_ADD_MODAL',
  CHANGE_PROPERTY: DOCUMENT + 'CHANGE_PROPERTY',
  TOUCH: DOCUMENT + 'TOUCH',
  SAVE: DOCUMENT + 'SAVE',

  loadData: data => ({
    type: actions.LOAD,
    payload: data,
  }),

  loadDataSuccess: data => ({
    type: actions.LOAD_SUCCESS,
    payload: data,
  }),

  clearStore: () => ({
    type: actions.CLEAR_STORE,
  }),

  delete: data => ({
    type: actions.DELETE,
    payload: data,
  }),

  add: data => ({
    type: actions.ADD,
    payload: data,
  }),

  save: data => ({
    type: actions.SAVE,
    payload: data,
  }),

  showEditModal: data => ({
    type: actions.SHOW_EDIT_MODAL,
    payload: data,
  }),

  closeModal: () => ({
    type: actions.CLOSE_MODAL,
  }),

  showAddModal: data => ({
    type: actions.SHOW_ADD_MODAL,
    payload: data,
  }),

  changeProperty: data => ({
    type: actions.CHANGE_PROPERTY,
    payload: data,
  }),

  touch: data => ({
    type: actions.TOUCH,
    payload: data,
  }),
};

export default actions;
